import { sendSignInLinkToEmail } from 'firebase/auth';

import { firebaseAuth } from '~/config/firebase.config';

/** Clé localStorage standard Firebase : permet à /link de retrouver l'email
 *  sans le redemander quand le lien est ouvert sur le MÊME appareil. */
export const EMAIL_FOR_SIGN_IN_KEY = 'emailForSignIn';

/**
 * Envoie le magic-link « continue sur ton ordinateur » (passerelle mobile et
 * bannière home). Le domaine d'origine doit être autorisé dans Firebase Auth
 * (prod : console.unboared.com ; dev : localhost l'est par défaut).
 */
export async function sendOnboardingLink(email: string, lang: string, from = 'bridge') {
    // Langue du template email Firebase = langue de l'interface.
    firebaseAuth.languageCode = (lang || 'fr').slice(0, 2);
    await sendSignInLinkToEmail(firebaseAuth, email, {
        // `from` : d'où vient la demande (passerelle, accueil téléphone, télécommande),
        // relu par /link pour la mesure.
        url: `${window.location.origin}/link?from=${encodeURIComponent(from)}`,
        handleCodeInApp: true,
    });
    try {
        localStorage.setItem(EMAIL_FOR_SIGN_IN_KEY, email);
    } catch {
        /* Safari privé — /link redemandera l'email. */
    }
}
